import PropTypes from 'prop-types';

import { DIGITAL_DELIVERY_ONLY_MESSAGE } from 'constants/siteMessages';

import ShippingDowngradeDetails from 'components/checkout/melody/shippingOption/ShippingDowngradeDetails';
import { formatShippingPrice } from 'helpers/CheckoutUtils';
import { toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/checkout/melody/shippingOption/shippingOption.scss';

const ShippingOption = ({ deliveryPromise, downgradeEstimateDollars, downgradeEstimatePoints, hasDigitalDelivery, hasRetailDelivery, isReviewStep, promise, shippingCharge, showShippingDowngradeBonus }, { testId }) => (
  <div data-test-id={testId('shipOptions')}>
    { !!hasRetailDelivery && makePhysicalShipping({ deliveryPromise, downgradeEstimateDollars, downgradeEstimatePoints, isReviewStep, promise, shippingCharge, showShippingDowngradeBonus }) }
    { !!hasRetailDelivery && !!hasDigitalDelivery && <hr /> }
    { !!hasDigitalDelivery && makeDigitalShipping() }
    { !hasRetailDelivery && !hasDigitalDelivery && makeNoShipOptions() }
  </div>
);

const makeNoShipOptions = () => (
  <>
    <strong>No shipment options available</strong>
    <p>More information provided in the order items section.</p>
  </>
);

const makePhysicalShipping = ({ deliveryPromise, downgradeEstimateDollars, downgradeEstimatePoints, isReviewStep, promise, shippingCharge, showShippingDowngradeBonus }) => {
  if (isReviewStep && !promise) {
    return 'No shipping options currently available. 1 or more items must be removed from the purchase. View purchase items for more information.';
  }

  if (!promise) {
    return 'Please add or select a shipping address to view delivery options.';
  }

  return (
    <>
      <div className={css.promiseLine}>
        { promise } { formatShippingPrice(shippingCharge) }
      </div>
      { deliveryPromise }
      {
        showShippingDowngradeBonus && !!downgradeEstimatePoints && <ShippingDowngradeDetails
          downgradeEstimatePoints={downgradeEstimatePoints}
          downgradeEstimateDollars={downgradeEstimateDollars}
          promise={promise}
          title={`You get ${toUSD(downgradeEstimateDollars)} in Zappos Rewards Points!`} />
      }
    </>
  );
};

const makeDigitalShipping = () => (
  <>
    <strong>Digital Delivery</strong>
    <p>{ DIGITAL_DELIVERY_ONLY_MESSAGE }</p>
  </>
);

ShippingOption.contextTypes = {
  testId: PropTypes.func
};

export default ShippingOption;
